import { PageStatus } from "@monthly/ui";
import { CssBaseline } from "@mui/material";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { Error404 } from "~/assets/svg";
import type { RouterContext } from "~/router";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <>
      <CssBaseline />
      <Outlet />
    </>
  );
}

function NotFound() {
  return (
    <PageStatus
      title="Nada por aquí"
      description="Lo sentimos no pudimos encontrar la página que buscas. Por favor, revisa que la dirección URL no tenga errores ortográficos. "
      icon={<Error404 />}
    />
  );
}
